import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        css: css`
            && th {
                background: ${color("common.ui7")};
                height: auto;
                padding: 8px 12px;
                border-bottom: 0;
                span[class*="IconWrapper"] {
                    width: 6px;
                    height: 6px;
                    color: white;
                    path {
                        fill: white;
                    }
                }
            }
            && td {
                text-align: start;
                border-bottom: 0;
                height: auto;
                padding: 8px 12px;
            }
            && tbody > tr {
                border-bottom: 1px solid ${getColor("common.ui5")};
                & :nth-child(even) {
                    background-color: ${color("common.ui4")};
                }
            }
            ${xScreen("lte", "sm")} {
                &.mobile-view {
                    word-wrap: break-word;
                    & thead {
                        display: none;
                    }
                    & td {
                        display: flex;
                        justify-content: space-between;
                        text-align: right;
                        width: 100%;
                        background: transparent;
                        padding: 12px;
                        -moz-box-sizing: border-box;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        white-space: break-spaces;
                        height: auto;
                        & > * {
                            max-width: 150px;
                        }
                        &:before {
                            content: attr(data-th);
                            font-size: 14px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 22px;
                            white-space: nowrap;
                            max-width: unset;
                        }
                    }
                    & tbody {
                        display: block;
                        border-top: 8px solid ${color("common.ui7")};
                        
                        @media print {
                            border-top: 2px solid ${color("common.ui7")};
                        }
                    }
                    & tr {
                        display: block;
                        height: auto;
                        background: ${color("common.white")};
                    }
                }
            }
        `,
        headerTypographyProps: {
            size: "14px",
            lineHeight: "22px",
            transform: "capitalize",
            weight: "bold",
            css: css`
                color: ${color("common.white")};
            `,
        },
        sortClickableProps: {
            css: css`
                width: 100%;
                height: 100%;
                justify-content: space-between !important;

                &&& {
                    svg {
                        color: ${color("common.white")};
                    }
                }
            `,
        },
        sortIconSources: {
            ...DataTablePresentationPropsDefault?.sortIconProps,
            sortable: "IconArrowDropdownSmall",
            ascending: "IconArrowSmallWhiteDown",
            descending: "IconArrowSmallWhiteUp",
        },
        cssOverrides: {
            header: css`
                background: ${color("common.ui7")};
                width: auto;
                text-align: left;
                text-transform: capitalize;
                border: 0;
                min-height: 19px;
                height: auto;
                padding: 6px 12px;
                th {
                    button {
                        justify-content: flex-start !important;
                    }
                }
            `,
            body: css`
                &&& {
                    a span {
                        font-size: 14px;
                        line-height: 22px;
                        color: ${color("common.ui8")};
                        font-weight: 500;
                    }
                }

                tr {
                    border-bottom: 1px solid ${color("common.ui5")};
                    &:nth-child(even) {
                        background-color: ${color("common.ui4")};
                    }
                }

                tr:focus {
                    cursor: pointer;
                }
            `,
            cell: css`
                padding: 8px 12px;
                height: auto;
                border: 0;
                font-size: 14px;
                line-height: 22px;
            `,
        },
        cellTypographyProps: {
            size: 14,
            lineHeight: "22px",
        },
    },
} as xBaseTheme["dataTable"];
